var SearchResultsConstants = require("../../cruise/modules/_search-results.constants");
var SearchResultsPointForm = require("../../commons/components/_search-results.points-form");

/**
 * FiltersLoaded and results Update come from Filters and Results view
 * This will help to check when render is done and loading can stop for both
 */

var SearchResultsView = Backbone.View.extend({
  events: {
    "click [data-page]": "processPageClick",
    "keyup [data-page]": "processPageClick",
    "click [data-sort]": "processSortClick",
    "keydown [data-sort]": "processSortClick",
    "click [data-filter]": "processFilterClick",
    "click [data-filter-clear]": "processFilterClearClick",
    "click [data-price]": "togglePrice",
    "click [data-view]": "toggleView",
    "click [data-compare-tray-clear]": "processCompareClearClick",
    "change [data-filter-range]": "processFilterClick",
    filtersUpdate: "processFilterClick",
    "change [data-sort-select]": "processSortSelect",
    "keyup [data-filter-input]": "processFilterInput",
    "click [data-select-sailing-button]": "checkTerms",
    "submit [data-points-input-form]": "processPointsChange",
    filtersLoaded: "processLoading",
    resultsUpdate: "processLoading"
  },

  setDefaults: function() {
    this.viewsInitialized = false;

    this.templates = {
      messagesTemplate: ""
    };

    this.statusRetry = 0;

    // If ie11 load low number of results
    ua = navigator.userAgent;

    var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

    var singlePageCount = is_ie ? 10 : 20;
    var groupPageCount = is_ie ? 5 : 10;

    this.settings = {
      defaultView: SearchResultsConstants.PAGE_TYPE_SINGLE,
      resultsPerPageSingle: singlePageCount,
      resultsPerPageGrouped: groupPageCount
    };

    this.activeRequests = 0;
    this.activeRequestTypes = {
      sailings: false,
      groups: false,
      summary: false,
      additionalData: false,
      statusCheck: false,
      analyticsData: false
    };

    this.additionalDataLoaded = false;
    this.analyticsDataLoaded = false;

    this.statusCheck = null;
    this.searchTimeout = null;
    this.filterDelay = null;
  },

  // Remove loading status of the results view and runs data-summary
  // if Results and Filters finished loading

  processLoading: function() {
    if (
      this.ResultsView.hasPage(
        this.StateModel.get("currentPage"),
        this.StateModel.get("currentView")
      )
    ) {
      this.ResultsView.stopLoading();

      this.FilterView.stopFilterLoading();

      // Adding the items count to the header of the search results
      // plus it helps while re-rendering single and grouped view
      // example: X items found

      if (this.$("[data-results-group-count]").length) {
        this.SummaryViewData.total_count =
          this.$("[data-results-group-count]").data("resultsGroupCount") ||
          this.SummaryViewData.total_count;
      } else if (this.$("[data-results-single-count]").length) {
        this.SummaryViewData.total_count =
          this.$("[data-results-single-count]").data("resultsSingleCount") ||
          this.SummaryViewData.total_count;
      } else {
        this.SummaryViewData.total_count = 0;
      }

      this.SummaryView.render(this.SummaryViewData);

      this.noResultsRendering(this.SummaryViewData.total_count);

      _.each(
        this.$("[data-messages]").find("[data-component='advisories']"),
        advisory => {
          $(advisory)
            .component()
            .reflow();
        }
      );
    }
  },

  // Process when custom advisory is set up for the search results page
  // and needs to be accepted in order to continue

  checkTerms: function(event) {
    var form = $(event.currentTarget).parent("form");

    if (this.termsDialog.length) {
      event.preventDefault();

      var Dialog = this.termsDialog.component();

      Dialog.reflow().open();

      Dialog.currentModal.on("click", "[data-terms-accepted]", function() {
        form.submit();
        Backbone.Events.trigger("loadingSplashOn");
      });
    } else {
      Backbone.Events.trigger("loadingSplashOn", event);
    }
  },

  // Pagination behavior to move from page to page

  processPageClick: function(event) {
    if (
      event.keyCode === 32 ||
      event.keyCode === 13 ||
      event.type === "click"
    ) {
      this.StateModel.set("currentPage", $(event.currentTarget).data("page"));

      switch (this.StateModel.get("currentView")) {
        case SearchResultsConstants.PAGE_TYPE_SINGLE:
          this.loadSailings();
          break;

        case SearchResultsConstants.PAGE_TYPE_GROUPED:
          this.loadSailingGroups();
          break;
      }
      this.processScrollTop();
    }
  },

  /**
   * after every single set of results is loaded,
   * page will go back to top of the results to
   * enhance the UX of the page
   */

  processScrollTop: function() {
    $("html, body").animate(
      {
        scrollTop: $("[data-results]").offset().top
      },
      1000
    );
  },

  /**
   * Process the selection of fancy select (B2C)
   * and sends data to changeSort, this is handled by the dropdown component
   */

  processSortClick: function(event) {
    let pressedKey =
      typeof event.which == "number" ? event.which : event.keyCode;

    if (event.type === "keyup" && pressedKey !== 13 && pressedKey !== 32) {
      return false;
    }

    let sortDirection = $(event.currentTarget).data("direction");
    let sortField = $(event.currentTarget).data("sort");

    if (
      (sortDirection === this.StateModel.get("currentSortDirection") &&
        sortField === this.StateModel.get("currentSortField")) ||
      !sortDirection
    ) {
      sortDirection =
        sortDirection === SearchResultsConstants.SORT_TYPE_ASC
          ? SearchResultsConstants.SORT_TYPE_DESC
          : SearchResultsConstants.SORT_TYPE_ASC;
    }

    this.changeSort(sortDirection, sortField);
  },

  // Process the selection of regular select (B2B)
  // and sends data to changeSort

  processSortSelect: function(event) {
    let selectedOption = $(event.currentTarget).find(":selected");

    let sortDirection = selectedOption.data("direction");
    let sortField = selectedOption.data("sort-item");

    this.changeSort(sortDirection, sortField);
  },

  // if there's data already in the StateModel auto
  // selects the correct sorting to display in the select box

  updateSortSelect: function() {
    this.$("[data-sort-select]:selected").removeAttr("selected");
    this.$(
      '[data-sort-select] > [data-direction="' +
        this.StateModel.get("currentSortDirection") +
        '"][data-sort-item="' +
        this.StateModel.get("currentSortField") +
        '"]'
    ).attr("selected", true);
  },

  // to do the Sorting we clear the results view
  // and then update the model with new parameters and
  // run to load more items

  changeSort: function(sortDirection, sortField) {
    this.ResultsView.clearPages();

    this.StateModel.set({
      currentSortDirection: !sortDirection
        ? SearchResultsConstants.SORT_TYPE_ASC
        : sortDirection,
      currentSortField: sortField,
      currentPage: 1
    });

    this.updateSortSelect();

    // unshift to make priority to this call in the queue
    switch (this.StateModel.get("currentView")) {
      case SearchResultsConstants.PAGE_TYPE_SINGLE:
        this.loadSailings();
        break;

      case SearchResultsConstants.PAGE_TYPE_GROUPED:
        this.loadSailingGroups();
        break;
    }
  },

  processFilterClick: function() {
    this.FilterView.startFilterLoading();

    this.ResultsView.clearPages();
    this.ResultsView.setLoading();

    this.ResultsView.render();

    this.StateModel.set({
      currentPage: 1,
      filters: this.FilterView.getSelectedFilters()
    });

    // unshift to make priority to this call in the queue
    switch (this.StateModel.get("currentView")) {
      case SearchResultsConstants.PAGE_TYPE_SINGLE:
        this.loadSailings();
        break;

      case SearchResultsConstants.PAGE_TYPE_GROUPED:
        this.loadSailingGroups();
        break;
    }
    this.processScrollTop();
  },

  processFilterClearClick: function() {
    this.ResultsView.clearPages();
    this.ResultsView.render();
    this.FilterView.resetFilters();

    this.StateModel.set({
      currentPage: 1,
      filters: {}
    });

    switch (this.StateModel.get("currentView")) {
      case SearchResultsConstants.PAGE_TYPE_SINGLE:
        this.loadSailings();
        break;

      case SearchResultsConstants.PAGE_TYPE_GROUPED:
        this.loadSailingGroups();
        break;
    }
  },

  processFilterInput: function() {
    if (this.filterDelay) {
      clearTimeout(this.filterDelay);
    }

    this.filterDelay = setTimeout(this.processFilterClick.bind(this), 1500);
  },

  processCompareClearClick: function() {
    this.ResultsView.clearCompareItems();
  },

  updatePriceRadio: function() {
    this.$("[data-price]").removeAttr("checked");
    this.$('[data-price="' + this.StateModel.get("currentPrice") + '"]').prop(
      "checked",
      true
    );
  },

  togglePrice: function(event) {
    this.StateModel.set("currentPrice", $(event.currentTarget).data("price"));

    this.ResultsView.togglePrice(this.StateModel.get("currentPrice"));
  },

  updateViewRadio: function() {
    this.$("[data-view]").removeAttr("checked");
    this.$('[data-view="' + this.StateModel.get("currentView") + '"]').prop(
      "checked",
      true
    );
  },

  toggleView: function(event) {
    this.StateModel.set({
      currentPage: 1,
      currentView: $(event.currentTarget).data("view")
    });

    switch (this.StateModel.get("currentView")) {
      case SearchResultsConstants.PAGE_TYPE_SINGLE:
        this.loadSailings();
        break;

      case SearchResultsConstants.PAGE_TYPE_GROUPED:
        this.loadSailingGroups();
        break;
    }
  },

  messages: {
    hasErrors: false,
    hasMessages: false,

    responseMessages: {
      fault: [],
      general: []
    },
    ajaxFailed: false,
    filterLoadingFailed: false,
    resultLoadingFailed: false,
    statusCheckFailed: false
  },

  clearMessages: function() {
    this.hasMessages = false;
    this.messages = {
      hasErrors: false,
      hasMessages: false,

      responseMessages: {
        fault: [],
        general: []
      },
      ajaxFailed: false,
      filterLoadingFailed: false,
      resultLoadingFailed: false,
      statusCheckFailed: false
    };
  },

  render: function() {
    if (!this.activeRequests) {
      this.$("[data-messages]").html(
        this.templates.messagesTemplate(this.messages)
      );

      this.$el.loadComponents();

      this.clearMessages();
    }
  },

  initViews: function() {
    this.updateSortSelect();
    this.updatePriceRadio();
    this.updateViewRadio();
    this.FilterView.setSelectedFilters(this.StateModel.get("filters"));

    if (
      this.ResultsView.hasPage(
        this.StateModel.get("currentPage"),
        this.StateModel.get("currentView")
      ) &&
      this.FilterView.isInitialized
    ) {
      this.render();
      this.viewsInitialized = true;
    } else {
      if (
        this.StateModel.get("currentView") ===
        SearchResultsConstants.PAGE_TYPE_GROUPED
      ) {
        this.loadSailingGroups();
      } else {
        this.loadSailings();
      }

      this.loadFiltersSummary(true);
    }
  },

  runFailure: function() {
    this.noResultsRendering();

    this.FilterView.stopFilterLoading(this.FilterView.sectionContainer);
    this.ResultsView.stopLoading();
    this.render();
  },

  processResponseMessages: function(response) {
    if (response.messages.fault.length) {
      this.messages.hasErrors = true;
      var currentFault = this.messages.responseMessages.fault;
      var newFault = response.messages.fault;

      this.messages.responseMessages.fault = currentFault.concat(newFault);
    }

    if (response.messages.general.length) {
      this.messages.hasMessages = true;

      var currentGeneral = this.messages.responseMessages.general;
      var newGeneral = response.messages.general;

      this.messages.responseMessages.fault = currentGeneral.concat(newGeneral);
    }
  },
  // This will control the display mode for the no results page
  noResultsRendering: function(items) {
    let itemsInSession = this.SummaryViewData.total_count || 0;
    this.$el.removeClass("no-results-page no-results-filter");

    if (!itemsInSession) {
      if (Object.keys(this.FilterViewData).length) {
        this.$el.addClass("no-results-filter");
        this.FilterView.stopFilterLoading(this.FilterView.sectionContainer);
      } else if (!Object.keys(this.FilterViewData).length && !itemsInSession) {
        this.$el.addClass("no-results-page");
      }

      this.SummaryView.hideView();
      this.$("[data-results]").html(this.templates.noResults());

      this.ResultsView.stopLoading();

      // initialize manageCustomer component once again to listen to no results actions

      $('[data-module="manage-customer"]').length
        ? $('[data-module="manage-customer"]')
            .component()
            .initialize()
        : false;

      this.$el.loadComponents();
      this.$el.loadModules();
    }
  },

  // In this method you will be able to
  // retrieve Filters and Results data
  // in results data there's a total count of all results

  loadFiltersSummary: function(isInit) {
    if (this.FilterView.isInitialized) {
      return;
    }

    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.selectionSummaryFilters,

      data: {
        st: this.settings.token
      },

      beforeSend: () => {
        if (this.activeRequestTypes.filters) {
          return false;
        }
        if (this.settings.bookingFlow === "cruise") {
          this.FilterView.startFilterLoading();
        }
        this.FilterView.setSelectedFilters(this.StateModel.get("filters"));

        this.activeRequestTypes.filters = true;
        this.activeRequests++;
      },

      success: response => {
        this.activeRequestTypes.filters = false;
        this.activeRequests--;

        this.processResponseMessages(response);

        if (response.data.processing) {
          this.queueStatusCheck();
        } else if (response.data.session_expired) {
          this.FilterView.hideView();
          this.SummaryView.hideView();
        } else if (response.success === true) {
          this.SummaryViewData = response.data.summary;
          this.FilterViewData = response.data.filters;
          this.FilterView.render(this.FilterViewData);
        }

        this.processLoading();
      },

      error: () => {
        this.activeRequestTypes.filters = false;
        this.activeRequests--;

        this.FilterView.hideView();
        this.messages.hasErrors = true;

        this.messages.filterLoadingFailed = true;
      }
    });
  },

  // process the response if are single items or grouped

  processingItems: function(response, itemType) {
    if (itemType === "single") {
      this.ResultsView.addSingleResultsPage(
        this.StateModel.get("currentPage"),
        response
      );

      this.ResultsView.render(
        this.StateModel.get("currentPage"),
        SearchResultsConstants.PAGE_TYPE_SINGLE
      );
    } else if (itemType === "grouped") {
      this.ResultsView.addGroupedResultsPage(
        this.StateModel.get("currentPage"),
        response
      );

      this.ResultsView.render(
        this.StateModel.get("currentPage"),
        SearchResultsConstants.PAGE_TYPE_GROUPED
      );
    }
  },

  loadSailings: function() {
    $.ajax({
      type: "GET",
      dataType: "html",
      cache: false,
      url: this.settings.urls.selectionSailings,

      data: {
        st: this.settings.token,
        pd: {
          p: this.StateModel.get("currentPage"),
          rpp: this.settings.resultsPerPageSingle,
          sf: this.StateModel.get("currentSortField"),
          sd: this.StateModel.get("currentSortDirection"),
          f: this.StateModel.getFilters()
        }
      },

      beforeSend: () => {
        if (
          this.ResultsView.hasPage(
            this.StateModel.get("currentPage"),
            SearchResultsConstants.PAGE_TYPE_SINGLE
          )
        ) {
          this.ResultsView.render(
            this.StateModel.get("currentPage"),
            SearchResultsConstants.PAGE_TYPE_SINGLE
          );
          return false;
        } else if (this.activeRequestTypes.sailings) {
          return false;
        }

        this.clearMessages();

        this.FilterView.startFilterLoading();
        this.ResultsView.setLoading();
        this.activeRequestTypes.sailings = true;
        this.activeRequests++;
      },

      success: response => {
        this.activeRequestTypes.sailings = false;
        this.activeRequests--;

        if ($(response).find("[data-processing]").length) {
          this.queueStatusCheck();
        } else if ($(response).find("[data-expired-session]").length) {
          this.expireSession();
        } else if ($(response).find("[data-results-single]").length) {
          this.extendSearchSession();

          this.processingItems(response, "single");
        } else {
          this.processingItems(response, "single");
        }

        this.ResultsView.togglePrice(this.StateModel.get("currentPrice"));

        this.loadFiltersSummary();

        this.processLoading();
      },

      error: () => {
        this.noResultsRendering();
        this.activeRequestTypes.sailings = false;
        this.activeRequests--;

        this.messages.hasErrors = true;
        this.messages.resultLoadingFailed = true;
      }
    });
  },

  loadSailingGroups: function() {
    $.ajax({
      type: "GET",
      dataType: "html",
      cache: false,
      url: this.settings.urls.selectionGroups,

      data: {
        st: this.settings.token,
        pd: {
          p: this.StateModel.get("currentPage"),
          rpp: this.settings.resultsPerPageSingle,
          sf: this.StateModel.get("currentSortField"),
          sd: this.StateModel.get("currentSortDirection"),
          f: this.StateModel.getFilters()
        }
      },

      beforeSend: () => {
        if (
          this.ResultsView.hasPage(
            this.StateModel.get("currentPage"),
            SearchResultsConstants.PAGE_TYPE_GROUPED
          )
        ) {
          this.ResultsView.render(
            this.StateModel.get("currentPage"),
            SearchResultsConstants.PAGE_TYPE_GROUPED
          );
          return false;
        } else if (this.activeRequestTypes.groups) {
          return false;
        }

        this.clearMessages();

        if (!this.FilterView.isInitialized) {
          this.FilterView.startFilterLoading();
        }

        this.ResultsView.setLoading();
        this.activeRequestTypes.groups = true;
        this.activeRequests++;
      },

      success: response => {
        this.activeRequestTypes.groups = false;
        this.activeRequests--;

        if ($(response).find("[data-processing]").length) {
          this.queueStatusCheck();
        } else if ($(response).find("[data-expired-session]").length) {
          this.expireSession();
        } else if ($(response).find("[data-results-group]").length) {
          this.extendSearchSession();

          this.processingItems(response, "grouped");
        } else {
          this.processingItems(response, "grouped");
        }

        this.ResultsView.togglePrice(this.StateModel.get("currentPrice"));

        this.loadFiltersSummary();

        this.processLoading();
      },

      error: () => {
        this.noResultsRendering();
        this.activeRequestTypes.groups = false;
        this.activeRequests--;

        this.messages.hasErrors = true;
        this.messages.resultLoadingFailed = true;
      }
    });
  },

  loadAdditionalData: function() {
    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.selectionAdditionalData,
      data: {
        st: this.settings.token
      },

      beforeSend: () => {
        if (
          this.activeRequestTypes.additionalData ||
          this.additionalDataLoaded
        ) {
          return false;
        }

        this.activeRequestTypes.additionalData = true;
        this.activeRequests++;
      },

      success: response => {
        this.activeRequestTypes.additionalData = false;
        this.activeRequests--;

        this.processResponseMessages(response);

        if (response.success === true) {
          this.FilterView.renderPromotions(
            response.data,
            this.StateModel.get("filters")
          );

          this.ResultsView.setPromotions(response.data.promotion_counts);
          this.ResultsView.setPromotionLogos(response.data.promotion_logos);
          this.ResultsView.setPromotionTags(response.data.promotion_tags);

          if (
            !this.ResultsView.hasPromotionsLoaded(
              this.StateModel.get("currentPage"),
              this.StateModel.get("currentView")
            )
          ) {
            this.ResultsView.render(
              this.StateModel.get("currentPage"),
              this.StateModel.get("currentView")
            );
          }
        } else {
          this.FilterView.renderPromotions();
        }

        this.processLoading();
      },

      error: () => {
        this.FilterView.renderPromotions();

        this.activeRequestTypes.additionalData = false;
        this.activeRequests--;
      }
    });
  },

  loadAnalyticsData: function() {
    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.selectionAnalyticsData,
      data: {
        st: this.settings.token
      },

      beforeSend: () => {
        if (this.activeRequestTypes.analyticsData || this.analyticsDataLoaded) {
          return false;
        }

        this.activeRequestTypes.analyticsData = true;
        this.activeRequests++;
      },

      success: response => {
        this.activeRequestTypes.analyticsData = false;
        this.activeRequests--;

        this.processResponseMessages(response);

        if (response.success === true) {
          Backbone.Events.trigger("publishAnalyticsData", response.data);
        }
      },

      error: () => {
        this.activeRequestTypes.analyticsData = false;
        this.activeRequests--;
      }
    });
  },

  expireSession: function() {
    this.ResultsView.clearPages();
    this.$("[data-expired-session-notice]")
      .component()
      .open();
  },

  extendSearchSession: function() {
    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.sessionExtend,
      data: {
        st: this.settings.token
      },

      beforeSend: () => {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
      },

      success: () => {
        this.searchTimeout = setTimeout(() => {
          this.expireSession();
        }, 1740000);
      },
      error: () => {}
    });
  },

  queueStatusCheck: function() {
    if (this.statusCheck) {
      clearTimeout(this.statusCheck);
    }

    setTimeout(() => {
      this.checkStatus();
    }, this.settings.requestDelay);
  },

  /**
   * Checks the status of the current queue to get Search Results
   *
   **/

  checkStatus: function() {
    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.searchStatus,
      data: {
        st: this.settings.token
      },

      beforeSend: () => {
        if (
          this.activeRequestTypes.statusCheck ||
          (this.statusRetry >= 99 && !this.viewsInitialized)
        ) {
          return false;
        } else {
          this.statusRetry++;
        }

        this.activeRequestTypes.statusCheck = true;
        this.activeRequests++;
        this.checkStatusComplete = false;
      },

      success: response => {
        this.activeRequestTypes.statusCheck = false;
        this.activeRequests--;

        this.processResponseMessages(response);

        if (response.success === true) {
          if (response.data.processing === true || !response.data.completed) {
            this.queueStatusCheck();
          }

          if (response.data.ready === true) {
            if (!this.viewsInitialized) {
              this.initViews();
            }

            if (!this.FilterView.isInitialized) {
              this.loadFiltersSummary(true);
            }
          }

          // If it hits the completed key, it means it
          // has finished loading and its ready for use

          if (response.data.completed === true) {
            this.loadAdditionalData();
            this.loadAnalyticsData();
            Backbone.Events.trigger("statusCheckComplete");

            // Results view has finished loading
            this.checkStatusComplete = true;
            this.processLoading();
          }
        } else if (response.data.session_expired) {
          this.expireSession();
        } else {
          if (response.data.completed === true) {
            this.runFailure();
            Backbone.Events.trigger("statusCheckComplete");
            // Results view has finished loading
            this.checkStatusComplete = true;
            this.processLoading();
          }

          this.messages.hasErrors = true;
          this.messages.statusCheckFailed = true;

          this.loadAnalyticsData();

          this.noResultsRendering();
        }
      },

      error: response => {
        this.activeRequestTypes.statusCheck = false;
        this.activeRequests--;

        this.hasErrors = true;
        this.messages.ajaxFailed = true;
        this.runFailure();

        this.loadAnalyticsData();
      }
    });
  },

  /**
   *
   * Interval points processor.
   * It handles both scenarios for input and the slider
   *
   * It uses the hardcoded form on selection.tpl and adds the point value to it.
   * Then the form just process as intended
   */
  processPointsChange: function(e) {
    if (e.type === "submit") {
      e.preventDefault();
    }

    let target = e.currentTarget || e.target;
    let currentAmount = $(target).find("[data-points-amount]");

    let modifyForm = this.$("[data-modify-search-form]");

    if (this.pointsWidget) {
      currentAmount = this.pointsWidget.validateInput(currentAmount);
    }

    let selectedPoints;

    if (typeof currentAmount == "number") {
      selectedPoints = currentAmount;
    } else {
      selectedPoints = currentAmount.text() || currentAmount.val();
      selectedPoints = selectedPoints.split(",").join("");
    }

    let pointInput = $(
      '<input type="hidden" name="points_selected" value="' +
        selectedPoints +
        '" data-points-input />'
    );

    modifyForm.append(pointInput);

    modifyForm.submit();
  },

  initialize: function(options) {
    this.setDefaults();

    this.templates.messagesTemplate = Handlebars.compile(
      this.$("[data-messages-template]").length
        ? this.$("[data-messages-template]").html()
        : ""
    );

    this.templates.noResults = Handlebars.compile(
      this.$("[data-no-results-template]").length
        ? this.$("[data-no-results-template]").html()
        : ""
    );

    if (this.$("[data-points-form-template]").length) {
      this.pointsWidget = new SearchResultsPointForm({
        el: this,
        container: this.$("[data-points-form-template]")
      });
    }

    this.currentItems = 0;
    this.FilterViewData = {};

    this.FilterView = options.FilterView;
    this.ResultsView = options.ResultsView;
    this.SummaryView = options.SummaryView;
    this.SponsoredResultsView = options.SponsoredResultsView;
    this.StateModel = options.StateModel;

    // this flag will be used to mark
    // when the page finished loading results
    this.checkStatusComplete = false;

    this.SummaryViewData = {};

    if (this.$el.data("settings")) {
      this.settings = $.extend(
        true,
        this.settings,
        JSON.parse(this.$el.data("settings"))
      );
    }

    if (sessionStorage.getItem("resultViewMode") === "singleView") {
      this.settings.defaultView = "single";
    }

    this.StateModel.set("currentView", this.settings.defaultView);

    if (this.settings.defaultSortField && this.settings.defaultSortDirection) {
      this.StateModel.set({
        currentSortField: this.settings.defaultSortField,
        currentSortDirection: this.settings.defaultSortDirection,
        currentPage: 1
      });
    }

    this.StateModel.set(
      JSON.parse(window.sessionStorage.getItem(this.settings.token))
    );

    this.StateModel.on("change", StateModel => {
      window.sessionStorage.setItem(
        this.settings.token,
        JSON.stringify(StateModel)
      );
    });

    if (this.settings.token) {
      this.initViews();
      this.checkStatus();
    } else {
      // Forcing to show error as is a major issue to be
      // missing search parameters
      this.messages.hasErrors = true;
      this.messages.responseMessages = {
        fault: [this.settings.tokenFailureMessage]
      };
      this.$el.addClass("no-results-page");
      this.runFailure();
    }

    this.termsDialog = this.$("[data-search-results-terms-modal]");
  }
});

module.exports = SearchResultsView;
